export default __webpack_public_path__ + "static/media/335.dc5573e8.gif";